import { render, staticRenderFns } from "./ItemIcon.vue?vue&type=template&id=7fb9d2fd"
import script from "./ItemIcon.vue?vue&type=script&lang=js"
export * from "./ItemIcon.vue?vue&type=script&lang=js"
import style0 from "./ItemIcon.vue?vue&type=style&index=0&id=7fb9d2fd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports